import { ProcedureStepService as OvermapProcedureStepService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepService extends OvermapProcedureStepService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
